import React from 'react';

export const DatabricksIcon = (): React.JSX.Element => {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="24" height="25" />
			<rect width="2974" height="1094" transform="translate(-1064 -613.559)" />
			<path
				d="M0 6.41265C0 2.88041 2.86345 0.0169678 6.39569 0.0169678H17.6043C21.1366 0.0169678 24 2.88041 24 6.41265V17.6213C24 21.1535 21.1366 24.017 17.6043 24.017H6.39569C2.86345 24.017 0 21.1535 0 17.6213V6.41265Z"
				fill="#FF3621"
			/>
			<path
				d="M18.156 15.3084V12.9538L17.9015 12.7947L11.7922 16.1357L6.00105 12.9538V11.5855L11.7922 14.7357L18.1879 11.2673V8.94453L17.9333 8.78544L11.7922 12.1583L6.22379 9.10363L11.7922 6.04897L16.2787 8.49906L16.6287 8.30815V8.05359L11.7922 5.41259L5.39648 8.8809V9.23091L11.7922 12.731L17.5833 9.5491V10.9492L11.7922 14.1311L5.65104 10.7582L5.39648 10.9173V13.272L11.7922 16.7403L17.5833 13.5902V14.9584L11.7922 18.1403L5.65104 14.7993L5.39648 14.9584V15.3084L11.7922 18.7767L18.156 15.3084Z"
				fill="white"
			/>
		</svg>
	);
};
